import {
    getRatePlan,
    listRatePlans
} from './queries';
import {
    createRatePlan,
    deleteRatePlan,
    updateRatePlan,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {RatePlan} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


export type ListRatePlans = {
    listRatePlans: { items: RatePlan[], nextToken: string }
}

export type GetRatePlan = {
    getRatePlan: RatePlan
}

export type CreateRatePlan = {
    createRatePlan: RatePlan
}

export type UpdateRatePlan = {
    updateRatePlan: RatePlan
}

export type DeleteRatePlan = {
    deleteRatePlan: string
}


const client = billingApiClient;

export const fetchRecords = async (query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListRatePlans>>({
                                                                           query: listRatePlans,
                                                                           variables: {
                                                                               ...query
                                                                           },
                                                                       });
    return {
        items: response.data?.listRatePlans.items,
        nextToken: response.data?.listRatePlans.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetRatePlan>>({
                                                                         query: getRatePlan,
                                                                         variables: {id: id},
                                                                     });
    return response.data?.getRatePlan;
};

export const add = async (payload: RatePlan) => {
    const response = await client.graphql<GraphQLQuery<CreateRatePlan>>(
        {
            query: createRatePlan,
            variables: {input: payload},
        });
    console.debug('in the service response', response);
    return response.data?.createRatePlan;
};

export const update = async (id: string, record: RatePlan) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateRatePlan>>({
                                                                            query: (updateRatePlan),
                                                                            variables: {input: record},
                                                                        });
    return response.data?.updateRatePlan;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteRatePlan>>({
                                                                            query: (deleteRatePlan),
                                                                            variables: {input: {id: id}},

                                                                        });
    return response.data?.deleteRatePlan;
};
